<template>
  <el-dialog
    title="选择一个操作员"
    :visible.sync="visible"
    width="600px"
    append-to-body=""
    @closed="handleClosed">
    <!-- <div class="search-form">
      <el-input
        v-model="config.name"
        placeholder="请输入姓名"
        style="width: 200px"
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div> -->
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        width="50">
        <template slot-scope="{row}">
          <el-radio
            v-model="current.staffId"
            :label="row.staffId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="姓名"
        prop="staffName">
      </el-table-column>
      <el-table-column
        label="账号"
        prop="account">
      </el-table-column>
    </el-table>
    <!-- <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange">
    </el-pagination> -->
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'UserSelectModal',
  components: {},
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        serviceId: null
      },
      inspectionNeedId: null,
      // totalNum: 0,
      current: {}
    }
  },
  watch: {
    current: {
      handler(val) {
        console.log(val)
      },
      deep: true
    }
  },
  created() { },
  mounted() { },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.config.pageNum = 1
      this.config.serviceId = null
      this.inspectionNeedId = null
      this.list = []
      this.current = {}
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    add() {
      if (!this.current.staffId) {
        this.$message.error('请选择一个操作员')
        return
      }
      this.loading = true
      this.$store.dispatch('account/assigninspectionneed', {
        payload: {
          inspectionNeedId: this.inspectionNeedId,
          acceptSgsId: this.current.orgId,
          acceptStaffId: this.current.staffId
        },
        success: () => {
          this.loading = false
          this.callback && this.callback()
          this.toggleModal(false)
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleCurrentRowChange(row) {
      console.log('handleCurrentRowChange', row)
      this.current = row || {}
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('account/getacceptablestaffs', {
        payload: this.config,
        success: res => {
          this.loading = false
          // this.totalNum = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.config.serviceId = row.serviceId
      this.inspectionNeedId = row.inspectionNeedId
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
